import React, { useMemo, useState } from 'react';
import { DbComponentItemType } from '@/pages/dashboard/types/dashboard';
import ComponentsMap from '@/pages/dashboard/_config/compontents';
interface DbComponentItemProps {
  info: DbComponentItemType;
  filterLoading: boolean;
  gameCode: string;
  formValue: any;
}

const DbComponentItem =  (props: DbComponentItemProps) => {
  const { info: { name }, gameCode, formValue, filterLoading } = props;
  // @ts-ignore
  const { Component } = ComponentsMap[name];
  return (
    <>
      {formValue && <Component gameCode={gameCode} formValue={formValue} filterLoading={filterLoading} />}
    </>
  );
}

export default DbComponentItem;
